import { useReadContract } from 'wagmi'

import { ProtocolDaoAbi } from '@/contracts/ProtocolDAO'
import { RewardsAbi } from '@/contracts/Rewards'

export const useGetGGPRewardsEligibilityMinSeconds = () => {
  const { data, isLoading } = useReadContract({
    abi: ProtocolDaoAbi,
    address: '0x41A76343eb93B4790e53c8E2789E09EF41195D0B',
    functionName: 'getRewardsEligibilityMinSeconds',
  })

  return { data, isLoading }
}

export const useGetGGPRewardsCycleSeconds = () => {
  const { data, isLoading } = useReadContract({
    abi: ProtocolDaoAbi,
    address: '0x41A76343eb93B4790e53c8E2789E09EF41195D0B',
    functionName: 'getRewardsCycleSeconds',
  })

  return { data, isLoading }
}

export const useGetGGPRewardsCycleStartTime = () => {
  const { data, isLoading } = useReadContract({
    abi: RewardsAbi,
    address: '0xAA8FD06cc3f1059b6d35870Bbf625C1Bac7c1B1D',
    functionName: 'getRewardsCycleStartTime',
  })

  return { data, isLoading }
}
